(function () {
  function initReveal() {
    var items = document.querySelectorAll('.bico-reveal, .bico-reveal-img');
    if (!items.length) return;
 
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
 
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
          setTimeout(function () {
            el.classList.add('is-visible');
          }, delay);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.15 });
 
    items.forEach(function (el) { observer.observe(el); });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
 
  document.addEventListener('shopify:section:load', initReveal);
})();
 